import { alternateHighchartsLegendClick } from './highcharts_custom.js';

window.Visualizations.Highcharts.Donut = Object.assign({}, window.Visualizations.Highcharts.Base, {
  render(opts) {
    const findSerie = (nameToMatch) => (serie) => serie.name === nameToMatch;

    const allSeries = opts.series;
    const activeSeries = allSeries.filter(findSerie(opts.default_series_name));

    const chartRoot = document.getElementById(opts.highchart_html_id);
    const select = chartRoot
      ?.closest('.visualization-container.visualizations-highcharts-donut')
      ?.querySelector('.donut-select select');

    const chart = this.renderChart(opts.highchart_html_id, opts, {
      chart: {
        type: 'pie',
        plotBackgroundColor: opts.plot_background_color,
        backgroundColor: opts.plot_background_color
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false
          },
          innerSize: '60%',
          point: {
            events: {
              legendItemClick: alternateHighchartsLegendClick
            }
          },
          size: '100%'
        }
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      series: activeSeries
    });

    const tooltipNumber = (tooltipHtml) => {
      const temp = document.createElement('div');
      temp.innerHTML = tooltipHtml;
      const divs = temp.querySelectorAll('div');
      return divs[divs.length - 1]?.textContent || '';
    };

    const adjustPieChartCenterText = () => {
      if (chart.customPieTitle) {
        chart.customPieTitle.destroy();
      }

      const r = chart.renderer;
      const x = chart.series[0].center[0] + chart.plotLeft;
      let y = chart.series[0].center[1] + chart.plotTop;

      let div = "<div style='text-align:center; color: black;'>";

      let totalHeading = opts.pie_chart_title;

      if (chart.options.template === 'ItalyIndustrialProductionByIndustrialSector') {
        totalHeading = 'Industrial production<br>(2016)';
      } else if (chart.options.template === 'FinanceReportInvestment') {
        totalHeading = 'Average annual<br> investment needs<br>(2018-30)';
        y -= y / 10;
      } else if (chart.options.template === 'FinanceReportCapexByFunding') {
        totalHeading = 'Average annual CAPEX<br> (2013-17)';
        y -= y / 15;
      }

      div += `<div style='font-size: ${20}px'>${totalHeading}</div><br>`;

      let total = chart.series[0].total;
      let tooltip = chart.tooltip.options.formatter.apply({ y: total, series: { name: 'test naa' } });
      let number = tooltipNumber(tooltip);

      if (number.slice(-1) === '%' && total > 100) {
        tooltip = chart.tooltip.options.formatter.apply({ y: 100 });
        number = tooltipNumber(tooltip);
      }

      if (total > 100) {
        total = 100;
      }

      if (chart.options.template === 'ChinaPppFundExample') {
        const usd = Math.round(total * 160) / 100;
        const cny = Math.round(total * 1) / 100;
        number = `CNY ${cny} billion<br>($${usd} million)`;
      } else if (chart.options.template === 'ItalyIndustrialProductionByIndustrialSector') {
        const euro = Math.round(total * 894.403) / 100;
        const usd = Math.round(total * 1252.1) / 100;

        number = `€${euro} billion<br>($${usd} bn)`;
      }

      if (chart.options.customTotal) {
        const rawPopulation = (chart.options.customTotal.raw_value * total) / 100;
        const formatedTotal = numeral(rawPopulation).format('0a').toUpperCase();
        number = `${formatedTotal}${chart.options.customTotal.prefix}`;
      }

      div += `<div style='font-size: ${15}px'>${number}</div>`;
      div += '</div>';

      chart.customPieTitle = r.text(div).hide().add();

      chart.customPieTitle.attr({
        x,
        y,
        'text-anchor': 'middle'
      }).show();
    };

    chart.adjustPieChartCenterText = adjustPieChartCenterText;
    chart.adjustPieChartCenterText();

    if (select) {
      select.addEventListener('change', function onChange() {
        const newCategory = this.value;
        chart.series[0].update({ data: opts.series.filter(findSerie(newCategory))[0].data }, true);
        chart.adjustPieChartCenterText();
      });
    }
  }
});
